import React from 'react';

const NotFoundIcon = ({ width = 259, height = 263, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 259 263'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M259 137C259 172.22 244.586 203.969 221.473 226.787C198.858 249.358 167.544 263 133 263C98.7042 263 67.3905 249.11 44.5266 226.787C21.4142 203.969 7 172.22 7 137C7 67.3032 63.4142 11 133 11C202.586 11 259 67.5512 259 137Z'
        fill='white'
      />
      <g filter='url(#filter0_d_1186_159702)'>
        <path
          d='M212.245 72.6527V177.704C212.245 182.076 208.745 185.54 204.454 185.54H46.218C41.9276 185.54 38.3711 182.02 38.3711 177.704V72.6527C38.3711 68.337 41.8712 64.8164 46.218 64.8164H204.454C208.745 64.8164 212.245 68.337 212.245 72.6527Z'
          fill='url(#paint0_linear_1186_159702)'
        />
      </g>
      <path
        d='M212.245 72.6527V84.407H38.3711V72.6527C38.3711 68.337 41.8712 64.8164 46.218 64.8164H204.454C208.745 64.8164 212.245 68.337 212.245 72.6527Z'
        fill='#495FED'
      />
      <path
        d='M49.3242 77.5384C50.9455 77.5384 52.2597 76.2164 52.2597 74.5856C52.2597 72.9548 50.9455 71.6328 49.3242 71.6328C47.703 71.6328 46.3887 72.9548 46.3887 74.5856C46.3887 76.2164 47.703 77.5384 49.3242 77.5384Z'
        fill='#AAB2C5'
      />
      <path
        d='M58.9199 77.5384C60.5412 77.5384 61.8554 76.2164 61.8554 74.5856C61.8554 72.9548 60.5412 71.6328 58.9199 71.6328C57.2987 71.6328 55.9844 72.9548 55.9844 74.5856C55.9844 76.2164 57.2987 77.5384 58.9199 77.5384Z'
        fill='#AAB2C5'
      />
      <path
        d='M68.4609 77.5384C70.0822 77.5384 71.3965 76.2164 71.3965 74.5856C71.3965 72.9548 70.0822 71.6328 68.4609 71.6328C66.8397 71.6328 65.5254 72.9548 65.5254 74.5856C65.5254 76.2164 66.8397 77.5384 68.4609 77.5384Z'
        fill='#AAB2C5'
      />
      <path
        d='M74.6719 155.955H175.948'
        stroke='#D5DAE5'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M90.6465 166.801H159.97'
        stroke='#D5DAE5'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M108.372 125.404V131.253H104.816V136.874H98.1542V131.253H83.4766V124.552L97.0816 105.529H104.872V125.461H108.372V125.404ZM98.1542 113.309L89.6863 125.404H98.1542V113.309Z'
        fill='#FF0004'
      />
      <path
        d='M125.082 137.499C117.969 137.499 111.703 131.253 111.703 121.145C111.703 111.037 117.913 104.791 125.082 104.791C132.252 104.791 138.461 111.037 138.461 121.145C138.461 131.253 132.252 137.499 125.082 137.499ZM125.082 131.48C128.413 131.48 131.743 128.129 131.743 121.202C131.743 114.274 128.413 110.924 125.082 110.924C121.751 110.924 118.421 114.274 118.421 121.202C118.421 128.129 121.751 131.48 125.082 131.48Z'
        fill='#FF0004'
      />
      <path
        d='M167.196 125.404V131.253H163.639V136.874H156.978V131.253H142.3V124.552L155.905 105.529H163.696V125.461H167.196V125.404ZM156.921 113.309L148.453 125.404H156.921V113.309Z'
        fill='#FF0004'
      />
      <path
        d='M204.559 208.738L166.738 170.948L175.409 162.277L213.199 200.098L204.559 208.738Z'
        fill='#AAB2C5'
      />
      <path
        d='M217.704 222.037L188.703 193.036C186.281 190.614 186.281 186.668 188.703 184.246C191.125 181.824 195.071 181.824 197.493 184.246L226.494 213.247C228.915 215.668 228.915 219.615 226.494 222.037C224.072 224.458 220.125 224.458 217.704 222.037Z'
        fill='#AAB2C5'
      />
      <path
        d='M215.644 223.888L178.332 186.576C177.465 185.708 177.465 184.303 178.332 183.406L187.869 173.869C188.736 173.002 190.141 173.002 191.038 173.869L228.351 211.181C229.218 212.048 229.218 213.453 228.351 214.35L218.813 223.888C217.916 224.755 216.511 224.755 215.644 223.888Z'
        fill='#1F2B7C'
      />
      <path
        d='M123.922 49.1758C84.3379 49.1758 52.2578 81.2559 52.2578 120.84C52.2578 160.395 84.3379 192.505 123.892 192.505C163.477 192.505 195.557 160.425 195.557 120.84C195.557 81.2559 163.477 49.1758 123.922 49.1758ZM123.922 179.23C92.1412 179.23 66.3994 153.07 66.3994 120.81C66.3994 88.5509 92.1412 62.4204 123.922 62.4204C155.703 62.4204 181.445 88.5808 181.445 120.84C181.445 153.1 155.674 179.23 123.922 179.23Z'
        fill='#1F2B7C'
      />
      <defs>
        <filter
          id='filter0_d_1186_159702'
          x={16.3711}
          y={53.8164}
          width={217.873}
          height={164.725}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy={11} />
          <feGaussianBlur stdDeviation={11} />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_1186_159702'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_1186_159702'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_1186_159702'
          x1={125.251}
          y1={62.024}
          x2={125.251}
          y2={186.842}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FDFEFF' />
          <stop offset={0.9964} stopColor='#ECF0F5' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default NotFoundIcon;
